export var ACCESS_TOKEN = 'access_token';
export var apigeeURL = 'https://api-qa.syf.com';
export var assetsURL = 'https://images.synchronycredit.com/';
export var AUTH_DOMAIN = 'https://auth-qa.syf.com';
export var mockAccountId = 'b586d946-5f5a-4fef-9697-753df5ffd7ea';
export var BASENAME = '/mfe';
export var defaultClientId = 'amazon';
export var LOGOUT_URL = "/v3/oauth2/logout";
export var MOCK_DATA = 'mockData';
export var synchronyLogo = "".concat(assetsURL, "/assets/synchrony/logo.svg");
export var LANG = {
    EN: 'en',
    ENGLISH: 'English',
    ES: 'es',
    SPANISH: 'Español'
};
export var ROUTES = {
    HOME: BASENAME,
    CALLBACK: "".concat(BASENAME, "/callback"),
    ERROR: "".concat(BASENAME, "/error"),
    LOGOUT: "".concat(BASENAME, "/logout"),
    NOT_FOUND: "".concat(BASENAME, "/*")
};
export var DASHBOARD = {
    HEADING: 'Good Afternoon'
};
export var LOGOUT_PAGE = {
    PAGE_TITLE: 'Logged Out',
    CARD_TITLE: 'Thank you for managing your Synchrony accounts.',
    CARD_DESCRIPTION: "You've securely logged out.",
    DEFAULT_BUTTON: 'LOG BACK IN',
    MOCK_DATA_BUTTON: 'BACK TO MOCK DATA'
};
export var NOT_FOUND_PAGE = {
    TITLE: "Sorry, we couldn't find that page.",
    CONTENT: "The page you're looking for either doesn't exist or can't be found.",
    GO_HOME: 'Go Back Home'
};
export var sessionKeys = {
    account: 'dc-mfe__selected-account',
    client: 'dc-mfe__selected-client',
    env: 'dc-mfe__selected-env',
    fromLogin: 'dc-mfe__from-login'
};
//# sourceMappingURL=sandbox-consts.js.map